import { DEFAULT_WORKOUT_WHEEL_CONFIG } from '../data/workoutWheelDefaults';
import type { WorkoutWheelConfig, WorkoutWheelExerciseRow } from '../types';

function clampInt(n: unknown, min: number, max: number, fallback: number): number {
  const v = typeof n === 'number' ? n : Number(n);
  if (!Number.isFinite(v)) return fallback;
  return Math.min(max, Math.max(min, Math.round(v)));
}

function isValidRow(x: unknown): x is WorkoutWheelExerciseRow {
  if (!x || typeof x !== 'object') return false;
  const o = x as Record<string, unknown>;
  return (
    typeof o.id === 'string' &&
    o.id.length > 0 &&
    typeof o.name === 'string' &&
    typeof o.prescription === 'string'
  );
}

function normalizeRows(raw: unknown, fallback: WorkoutWheelExerciseRow[]): WorkoutWheelExerciseRow[] {
  if (!Array.isArray(raw)) return fallback;
  const rows = raw.filter(isValidRow);
  return rows.length > 0 ? rows : fallback;
}

/** Merge saved JSON with built-in defaults so older rows stay valid. */
export function normalizeWorkoutWheelConfig(raw: unknown): WorkoutWheelConfig {
  const d = DEFAULT_WORKOUT_WHEEL_CONFIG;
  if (!raw || typeof raw !== 'object') {
    return { ...d, green: [...d.green], yellow: [...d.yellow], red: [...d.red] };
  }
  const o = raw as Record<string, unknown>;
  return {
    spinCount: clampInt(o.spinCount, 1, 20, d.spinCount),
    copiesGreen: clampInt(o.copiesGreen, 1, 10, d.copiesGreen),
    copiesYellow: clampInt(o.copiesYellow, 1, 10, d.copiesYellow),
    copiesRed: clampInt(o.copiesRed, 1, 10, d.copiesRed),
    green: normalizeRows(o.green, d.green),
    yellow: normalizeRows(o.yellow, d.yellow),
    red: normalizeRows(o.red, d.red),
  };
}
